import { useState, useEffect } from "react";
const BASE = "https://imalishawelfare.com/api";
const tok = () => sessionStorage.getItem("token") || localStorage.getItem("adminToken") || localStorage.getItem("token");
const fmt = n => "KSh " + Number(n||0).toLocaleString("en-KE");

export default function FollowUp() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("NOT_STARTED");
  const [search, setSearch] = useState("");
  const [sending, setSending] = useState({});
  const [toast, setToast] = useState({ msg:"", type:"" });
  const [selected, setSelected] = useState([]);
  const [bulkLoading, setBulkLoading] = useState(false);

  const showToast = (msg, type="success") => { setToast({ msg, type }); setTimeout(() => setToast({ msg:"", type:"" }), 4000); };

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${BASE}/applications`, { headers:{ Authorization:"Bearer "+tok() } });
      if (r.ok) setApps(await r.json());
    } catch(e) {}
    setLoading(false);
  };

  const sendReminder = async (app) => {
    setSending(s => ({ ...s, [app.id]: true }));
    try {
      await fetch(`${BASE}/admin/send-email`, {
        method: "POST",
        headers: { Authorization:"Bearer "+tok(), "Content-Type":"application/json" },
        body: JSON.stringify({
          to: app.email,
          subject: "Action Required - Complete Your Imalisha Welfare Loan",
          message: `Dear ${app.fullName},\n\nYour loan application has been approved. Please log in at https://imalishawelfare.com/login to select your loan amount and pay the processing fee.\n\nYour credentials were sent in a previous email. Contact us at Toll-Free 1533 if you need help.\n\nImalisha Welfare Loan Programme`
        })
      });
      showToast(`Reminder sent to ${app.fullName}`);
    } catch(e) { showToast("Failed: " + e.message, "error"); }
    setSending(s => ({ ...s, [app.id]: false }));
  };

  const sendBulkReminders = async () => {
    const targets = filtered.filter(a => selected.includes(a.id));
    if (!targets.length) { showToast("Select applicants first", "error"); return; }
    if (!window.confirm(`Send reminder to ${targets.length} applicants?`)) return;
    setBulkLoading(true);
    let success = 0;
    for (const app of targets) {
      try {
        await fetch(`${BASE}/admin/send-email`, {
          method: "POST",
          headers: { Authorization:"Bearer "+tok(), "Content-Type":"application/json" },
          body: JSON.stringify({
            to: app.email,
            subject: "Action Required - Complete Your Imalisha Welfare Loan",
            message: `Dear ${app.fullName},\n\nYour loan application has been approved. Please log in at https://imalishawelfare.com/login to complete your loan process.\n\nImalisha Welfare Loan Programme`
          })
        });
        success++;
      } catch(e) {}
      await new Promise(r => setTimeout(r, 500));
    }
    showToast(`Sent ${success}/${targets.length} reminders!`);
    setSelected([]);
    setBulkLoading(false);
  };

  const toggleSelect = (id) => setSelected(s => s.includes(id) ? s.filter(x=>x!==id) : [...s, id]);
  const selectAll = () => { if (selected.length === filtered.length) setSelected([]); else setSelected(filtered.map(a=>a.id)); };

  const getCategory = (a) => {
    if (a.loanStatus === "PAYMENT_FAILED") return "FAILED";
    if (a.loanStatus === "PENDING_FEE") return "PENDING";
    if (a.loanStatus === "FEE_PAID") return "FEE_PAID";
    if (a.loanStatus === "DISBURSED" || a.status === "DISBURSED") return "DONE";
    if (a.status === "APPROVED" && !a.loanStatus) return "NOT_STARTED";
    return "OTHER";
  };

  const categories = {
    NOT_STARTED: { label:"Not Started", color:"#f59e0b", bg:"#fff8e6", desc:"Never logged in" },
    PENDING: { label:"Payment Pending", color:"#0066cc", bg:"#eff6ff", desc:"STK sent" },
    FAILED: { label:"Payment Failed", color:"#ef4444", bg:"#fee2e2", desc:"Payment failed" },
    FEE_PAID: { label:"Fee Paid", color:"#7c3aed", bg:"#f5f3ff", desc:"Awaiting disburse" },
    DONE: { label:"Disbursed", color:"#10b981", bg:"#f0fdf4", desc:"Complete" },
  };

  const counts = {};
  apps.filter(a=>a.status==="APPROVED"||a.status==="DISBURSED").forEach(a => { const c = getCategory(a); counts[c] = (counts[c]||0) + 1; });

  const filtered = apps.filter(a => {
    const matchFilter = filter === "ALL" || getCategory(a) === filter;
    const q = search.toLowerCase();
    const matchSearch = !q || a.fullName?.toLowerCase().includes(q) || a.phone?.includes(q) || a.email?.toLowerCase().includes(q) || a.county?.toLowerCase().includes(q);
    return matchFilter && matchSearch && (a.status === "APPROVED" || a.status === "DISBURSED");
  });

  return (
    <div style={{ fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif" }}>
      {toast.msg && <div style={{ position:"fixed", top:20, right:20, zIndex:9999, background:toast.type==="error"?"#ef4444":"#10b981", color:"white", padding:"12px 20px", borderRadius:10, fontSize:13, fontWeight:600, boxShadow:"0 4px 16px rgba(0,0,0,0.2)" }}>{toast.msg}</div>}

      <div style={{ background:"linear-gradient(135deg,#1e293b,#0f172a)", borderRadius:12, padding:"24px 28px", marginBottom:24 }}>
        <h2 style={{ color:"white", fontSize:20, fontWeight:800, margin:"0 0 4px" }}>Follow-Up Tracker</h2>
        <p style={{ color:"rgba(255,255,255,0.6)", fontSize:13, margin:"0 0 20px" }}>Track applicants who have not completed their loan process</p>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))", gap:10 }}>
          {Object.entries(categories).map(([key, cat]) => (
            <div key={key} onClick={()=>setFilter(key)} style={{ background:filter===key?"rgba(255,255,255,0.2)":"rgba(255,255,255,0.08)", border:`1.5px solid ${filter===key?"rgba(255,255,255,0.4)":"rgba(255,255,255,0.1)"}`, borderRadius:8, padding:"12px 14px", cursor:"pointer" }}>
              <p style={{ color:"rgba(255,255,255,0.6)", fontSize:10, fontWeight:600, margin:"0 0 4px", textTransform:"uppercase", letterSpacing:.5 }}>{cat.label}</p>
              <p style={{ color:"white", fontSize:22, fontWeight:800, margin:"0 0 2px" }}>{counts[key]||0}</p>
              <p style={{ color:"rgba(255,255,255,0.4)", fontSize:10, margin:0 }}>{cat.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div style={{ background:"white", borderRadius:10, padding:"14px 16px", marginBottom:16, boxShadow:"0 1px 4px rgba(0,0,0,0.06)", display:"flex", gap:10, flexWrap:"wrap", alignItems:"center" }}>
        <div style={{ position:"relative", flex:1, minWidth:200 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2" style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)" }}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search name, phone, email, county..." style={{ width:"100%", padding:"8px 10px 8px 32px", border:"1px solid #e2e8f0", borderRadius:7, fontSize:13, boxSizing:"border-box" }}/>
        </div>
        <span style={{ color:"#94a3b8", fontSize:12 }}>{filtered.length} records</span>
        {selected.length > 0 && (
          <button onClick={sendBulkReminders} disabled={bulkLoading} style={{ padding:"8px 16px", background:"#0052a3", color:"white", border:"none", borderRadius:7, fontSize:12, fontWeight:700, cursor:"pointer" }}>
            {bulkLoading ? "Sending..." : `Send Reminder to ${selected.length} Selected`}
          </button>
        )}
        <button onClick={load} style={{ padding:"8px 14px", background:"#f1f5f9", color:"#64748b", border:"none", borderRadius:7, fontSize:12, fontWeight:600, cursor:"pointer" }}>Refresh</button>
      </div>

      <div style={{ background:"white", borderRadius:12, boxShadow:"0 1px 6px rgba(0,0,0,0.06)", overflow:"hidden" }}>
        {loading ? <div style={{ padding:48, textAlign:"center", color:"#94a3b8" }}>Loading...</div> : (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr style={{ background:"#f8fafc" }}>
                  <th style={{ padding:"10px 14px" }}><input type="checkbox" checked={selected.length===filtered.length&&filtered.length>0} onChange={selectAll} style={{ cursor:"pointer" }}/></th>
                  {["APP","Applicant","Phone","County","Status","Loan","Action"].map(h=>(
                    <th key={h} style={{ padding:"10px 14px", textAlign:"left", fontWeight:600, color:"#64748b", fontSize:11, textTransform:"uppercase", whiteSpace:"nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length===0 ? <tr><td colSpan={8} style={{ padding:32, textAlign:"center", color:"#94a3b8" }}>No records</td></tr> :
                filtered.map((a,i) => {
                  const cat = getCategory(a);
                  const catInfo = categories[cat]||categories["NOT_STARTED"];
                  return (
                    <tr key={a.id} style={{ borderTop:"1px solid #f1f5f9", background:selected.includes(a.id)?"#eff6ff":i%2?"#fafafa":"white" }}>
                      <td style={{ padding:"10px 14px" }}><input type="checkbox" checked={selected.includes(a.id)} onChange={()=>toggleSelect(a.id)} style={{ cursor:"pointer" }}/></td>
                      <td style={{ padding:"10px 14px", color:"#0066cc", fontWeight:700 }}>APP-{a.id}</td>
                      <td style={{ padding:"10px 14px" }}>
                        <div style={{ fontWeight:600, color:"#1e293b" }}>{a.fullName}</div>
                        <div style={{ fontSize:11, color:"#94a3b8" }}>{a.email}</div>
                      </td>
                      <td style={{ padding:"10px 14px", fontFamily:"monospace", color:"#334155" }}>{a.phone||"�"}</td>
                      <td style={{ padding:"10px 14px", color:"#64748b" }}>{a.county||"�"}</td>
                      <td style={{ padding:"10px 14px" }}><span style={{ background:catInfo.bg, color:catInfo.color, borderRadius:4, padding:"3px 9px", fontSize:11, fontWeight:700 }}>{catInfo.label}</span></td>
                      <td style={{ padding:"10px 14px", fontWeight:700, color:"#0052a3" }}>{a.selectedLoanAmount ? fmt(a.selectedLoanAmount) : <span style={{ color:"#94a3b8" }}>Not selected</span>}</td>
                      <td style={{ padding:"10px 14px" }}>
                        <div style={{ display:"flex", gap:5 }}>
                          {cat !== "DONE" && <button onClick={()=>sendReminder(a)} disabled={sending[a.id]} style={{ padding:"5px 10px", background:"#0052a3", color:"white", border:"none", borderRadius:5, fontSize:11, fontWeight:600, cursor:"pointer", whiteSpace:"nowrap", opacity:sending[a.id]?0.6:1 }}>{sending[a.id]?"Sending...":"Remind"}</button>}
                          <a href={`tel:${a.phone}`} style={{ padding:"5px 10px", background:"#f0fdf4", color:"#16a34a", borderRadius:5, fontSize:11, fontWeight:600, textDecoration:"none" }}>Call</a>
                          <a href={`mailto:${a.email}`} style={{ padding:"5px 10px", background:"#fef3c7", color:"#92400e", borderRadius:5, fontSize:11, fontWeight:600, textDecoration:"none" }}>Email</a>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        <div style={{ padding:"12px 16px", borderTop:"1px solid #e2e8f0", background:"#f8fafc", display:"flex", gap:20, flexWrap:"wrap" }}>
          {Object.entries(categories).map(([key,cat])=>(
            <span key={key} style={{ fontSize:12, color:cat.color }}>{cat.label}: <strong>{counts[key]||0}</strong></span>
          ))}
        </div>
      </div>
    </div>
  );
}
